import { render, staticRenderFns } from "./TicketRoom.vue?vue&type=template&id=36eee72b&scoped=true"
import script from "./TicketRoom.vue?vue&type=script&lang=js"
export * from "./TicketRoom.vue?vue&type=script&lang=js"
import style0 from "./TicketRoom.vue?vue&type=style&index=0&id=36eee72b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eee72b",
  null
  
)

export default component.exports